'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ContentCardHeader = require('./ContentCardHeader.css');

var _ContentCardHeader2 = _interopRequireDefault(_ContentCardHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContentCardHeader = function ContentCardHeader(props) {
  return _react2.default.createElement(
    'div',
    {
      className: 'jsx-' + _ContentCardHeader2.default.__scopedHash + ' ' + ('header ' + (props.isLarge ? 'containerLarge' : 'container'))
    },
    props.iconType && _react2.default.createElement('div', {
      className: 'jsx-' + _ContentCardHeader2.default.__scopedHash + ' ' + ('icon ' + props.iconType + 'Icon')
    }),
    _react2.default.createElement(_style2.default, {
      styleId: _ContentCardHeader2.default.__scopedHash,
      css: _ContentCardHeader2.default.__scoped
    })
  );
};

ContentCardHeader.propTypes = {
  iconType: _propTypes2.default.oneOf(['twitter', 'instagram', 'read']),
  isLarge: _propTypes2.default.bool
};

ContentCardHeader.defaultProps = {
  iconType: null,
  isLarge: false
};

exports.default = ContentCardHeader;